<template>
  <div class="mx-5 mx-md-16 px-md-16">
    <v-data-table
      :headers="headers"
      :items="rows.items"
      :items-per-page="-1"
      hide-default-footer
      disable-sort
      class="elevation-1 rounded-lg"
    >
      <template v-slot:item.date="{ item }">
        {{ formatDate(item.date) }}
      </template>
      <template v-slot:item.status="{ item }">
        {{ getStatusText(item.status) }}
      </template>
    </v-data-table>
    <div class="pt-2 d-flex flex-column flex-md-row align-center justify-end">
      <span class="font-quicksand">Filas por páginas: </span>
      <span style="width: 50px" class="mx-md-2">
        <v-select
          v-model="itemsPerPage"
          :items="itemsPerPages"
          class="font-quicksand"
          @change="onItemsPerPageChange"
        ></v-select>
      </span>
      <span class="font-quicksand"
        >{{ rowsRangeStart }}-{{ rowsRangeEnd }} de {{ rows.totalItems }}
      </span>
      <v-pagination
        v-model="page"
        :length="rows.totalPages"
        :total-visible="pageVisible"
        color="red"
        class="font-work-sans"
        @input="onPageChange"
      ></v-pagination>
    </div>
  </div>
</template>

<script>
import Repository from '@/repositories/RepositoryFactory'
import { createPaginationMixin } from '@/mixins/pagination'
const AppointmentRepository = Repository.get('appointments')
import { format } from 'date-fns'

const APPOINTMENT_STATUS = {
  pending: 'Pendiente',
  finished: 'Finalizada',
  canceled: 'Cancelada',
}

export default {
  name: 'AppointmentList',
  props: ['search', 'newItem'],
  mixins: [createPaginationMixin({ debounceMs: 500 })],
  data: () => ({
    headers: [
      {
        text: 'Fecha',
        align: 'center',
        class: 'primary white--text font-weight-bold text-subtitle-2',
        value: 'date',
      },
      {
        text: 'Hora',
        align: 'center',
        class: 'primary white--text font-weight-bold text-subtitle-2',
        value: 'time',
      },
      {
        text: 'Cédula',
        align: 'center',
        class: 'primary white--text font-weight-bold text-subtitle-2',
        value: 'patientId',
      },
      {
        text: 'Nombre',
        align: 'center',
        class: 'primary white--text font-weight-bold text-subtitle-2',
        value: 'patient.firstName',
      },
      {
        text: 'Apellido',
        align: 'center',
        class: 'primary white--text font-weight-bold text-subtitle-2',
        value: 'patient.lastName',
      },

      {
        text: 'Estatus',
        align: 'center',
        class: 'primary white--text font-weight-bold text-subtitle-2',
        value: 'status',
      },
      {
        text: 'Atendido por',
        align: 'center',
        class: 'primary white--text font-weight-bold text-subtitle-2',
        value: 'finishedBy',
      },
      {
        text: 'Hora de atención',
        align: 'center',
        class: 'primary white--text font-weight-bold text-subtitle-2',
        value: 'finishedTime',
      },
    ],
    itemsPerPages: [10, 20, 30, 50, 100],
  }),
  watch: {
    newItem: function (val) {
      if (val) this.loadData()
    },
  },
  methods: {
    fetchPage: function (params) {
      return AppointmentRepository.get(params)
    },
    getStatusText(status) {
      return APPOINTMENT_STATUS[status]
    },
    formatDate: (value) => {
      const date = value ? new Date(value) : new Date()
      return format(date, 'dd/MM/yyyy')
    },
  },
}
</script>
